import { useContext } from 'react';
import { useIntl } from 'gatsby-plugin-react-intl';
import PropTypes from 'prop-types';

import { CoreContext } from '../..';
import { FormatInterest } from '../../../../Core/CurrencyFormatter';

import { StyledSpan } from './styles';

const InterestsValueComponent = ({ data }) => {
  if (!data) return null;
  const intl = useIntl();
  const { core } = useContext(CoreContext);

  const { color, textUnderline } = data;

  const totalRates = core.rates.promoInterestRate
    ? core.rates.promoInterestRate
    : core.rates.baseInterestRate;

  return (
    <>
      {totalRates && (
        <StyledSpan
          $color={color}
          $textUnderline={textUnderline}
        >{`${FormatInterest(totalRates, intl.locale)}`}</StyledSpan>
      )}
    </>
  );
};

InterestsValueComponent.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default InterestsValueComponent;
